module.exports = __webpack_public_path__ + "img/jgh2.423764e6.jpg";